const faqs = [
  {
    q: '虫虫动漫需要付费吗？怎么注册？',
    a: '完全不需要！虫虫动漫是免费漫画与免费看漫画在线平台，所有漫画资源均免费提供，无需注册即可直接阅读。下拉式滚动浏览即点即看，不需要付费订阅或购买会员。我们致力于让每一位漫画爱好者都能零门槛畅享海量免费动漫全集。',
  },
  {
    q: '如何快速找到我想看的免费漫画？',
    a: '您可以通过首页的热门话题标签、分类索引或者热度榜单快速定位感兴趣的免费漫画。也可以使用搜索功能输入漫画名称、作者或关键词，系统会智能匹配相关结果。每个漫画都有详细标签，帮助您精准找到同类型作品。',
  },
  {
    q: '漫画的更新频率是怎样的？',
    a: '虫虫动漫每日同步更新1000+话免费漫画内容，日本热门连载作品基本实现同步更新。国内漫画同样保持高速更新节奏。您可以在更新动态模块查看最新上架的章节，不会错过任何一话精彩内容。',
  },
  {
    q: '阅读时遇到问题怎么办？如何反馈？',
    a: '如果您在阅读免费在线漫画时遇到加载缓慢、图片显示异常等问题，可以尝试刷新页面或切换网络环境。对于内容建议、版权问题或商务合作，欢迎通过联系我们模块与我们取得联系，我们会尽快处理您的反馈。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-18 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center">
            常见问答
          </h2>
          <p className="mt-2 text-sm text-foreground-500 text-center">
            关于虫虫动漫，你想知道的都在这里
          </p>
          <div className="mt-8 space-y-3">
            {faqs.map((faq, idx) => (
              <details
                key={idx}
                className="group bg-background-100 rounded-xl border border-background-200/70 overflow-hidden"
                open={idx === 0}
              >
                <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                  <h3 className="text-sm font-medium text-foreground-800 pr-4">
                    {faq.q}
                  </h3>
                  <span className="w-6 h-6 flex items-center justify-center shrink-0 text-foreground-400 group-open:rotate-45 transition-transform duration-200">
                    <i className="ri-add-line"></i>
                  </span>
                </summary>
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}